import { Component } from '@angular/core';
import { DivestmentMilestoneComponent } from '../divestment-milestone/divestment-milestone.component';
import { OwnershipMilestoneId } from 'src/app/shared/model/divestment/OwnershipMilestoneId';

@Component({
  selector: 'digires-divestment-end-of-process',
  templateUrl: './divestment-end-of-process.component.html',
  styleUrls: ['./divestment-end-of-process.component.scss']
})
export class DivestmentEndOfProcessComponent extends DivestmentMilestoneComponent {

  override emitEvent() {
    this.formGroup.patchValue({
      [this.getFormControlNameComplete()]: this.isComplete(),
    });
    super.emitEvent();
  }

  getEndOfProcessCheckboxTooltip(): string {
    if (this.milestoneId === OwnershipMilestoneId.A_S4_END_PRO) {
      return "Includes the completion of legally binding agreement to Acquire project shares at a future date.";
    }
    if (this.milestoneId === OwnershipMilestoneId.D_S4_END_PRO) {
      return "Includes the completion of legally binding agreement to Divest the project at a future date.";
    }
    else return null;
  }

  override isDone(): boolean {
    return this.isComplete();
  }

  override isComplete(): boolean {
    return this.isAcquired() || this.isRejected();
  }

  override isNotAvailable(): boolean {
    return false;
  }

  isRejected(): boolean {
    return !!this.formGroup.value[this.getFormControlNameRejected()];
  }

  isRejectedDirty(): boolean {
    return this.formGroup.get(this.getFormControlNameRejected()).dirty;
  }

  isAcquired(): boolean {
    return !!this.formGroup.value[this.getFormControlNameAcquired()];
  }

  isAcquiredDirty(): boolean {
    return this.formGroup.get(this.getFormControlNameAcquired()).dirty;
  }

  getFormControlNameRejected(): string {
    return 'rejected';
  }

  getFormControlNameAcquired(): string {
    return 'acquired';
  }

}
